import React, { useRef, useState, useCallback } from 'react';
import './AdvisorBox.scss';
import { useTranslation } from 'react-i18next';
import { useAccount } from '../../../contexts/account/AccountContexts';
import { PAID_ADVISOR, TRIAL_ADVISOR } from '../../../constans/constans';
import advisorAvatarTrial from '../../../../assets/images/advisor-avatar-trial.gif';
import advisorAvatarPaid from '../../../../assets/images/advisor-avatar-paid.gif';

const NARROW_MENU_BREAKPOINT = 1430;

const AdvisorBox: React.FC = () => {
  const { t } = useTranslation();
  const { accountResponse } = useAccount();
  const boxRef = useRef<HTMLDivElement>(null);
  const [popupPos, setPopupPos] = useState<{ top: number; left: number } | null>(null);

  const isTrial = accountResponse?.accountType === 'TRIAL';
  const advisor = isTrial ? TRIAL_ADVISOR : PAID_ADVISOR;
  const advisorAvatar = isTrial ? advisorAvatarTrial : advisorAvatarPaid;

  const showPopup = useCallback(() => {
    if (!boxRef.current || window.innerWidth > NARROW_MENU_BREAKPOINT) return;
    const rect = boxRef.current.getBoundingClientRect();
    setPopupPos({ top: rect.top, left: rect.right + 8 });
  }, []);

  const hidePopup = useCallback(() => {
    setPopupPos(null);
  }, []);

  return (
    <div
      className="advisor-box"
      ref={boxRef}
      onMouseEnter={showPopup}
      onMouseLeave={hidePopup}
    >
      <div className="advisor-box__title">{t('advisor.title')}</div>
      <div className="advisor-box__card">
        <img className="advisor-box__avatar" src={advisorAvatar} alt={advisor.name} />
        <div className="advisor-box__info">
          <span className="advisor-box__name">{advisor.name}</span>
          <a className="advisor-box__email" href={`mailto:${advisor.email}`}>
            {advisor.email}
          </a>
        </div>
      </div>
      <a
        href={advisor.calendly}
        target="_blank"
        rel="noopener noreferrer"
        className="advisor-box__demo-btn"
      >
        {t('bookADemo')}
      </a>
      {popupPos && (
        <div
          className="advisor-box__popup"
          style={{ top: popupPos.top, left: popupPos.left }}
        >
          <div className="advisor-box__card">
            <img className="advisor-box__avatar" src={advisorAvatar} alt={advisor.name} />
            <div className="advisor-box__info">
              <span className="advisor-box__name">{advisor.name}</span>
              <a className="advisor-box__email" href={`mailto:${advisor.email}`}>
                {advisor.email}
              </a>
            </div>
          </div>
          <a
            href={advisor.calendly}
            target="_blank"
            rel="noopener noreferrer"
            className="advisor-box__demo-btn"
          >
            {t('bookADemo')}
          </a>
        </div>
      )}
    </div>
  );
};

export default AdvisorBox;
